<template>
  <div class="placeOrder"
       v-loading='fullscreenLoading'>
    <div class="placeOrder_top">
      <div class="top_view">
        <el-form :model="inquiry"
                 ref="inquiry"
                 :rules="inquiryRules"
                 label-position="top"
                 label-width="100px"
                 class="inquiry_form">
          <!-- <el-form-item label='运输类型'
                        prop="type">
            <el-select v-model="inquiry.type"
                       placeholder="请选择运输类型">
              <el-option v-for="item in transportationType"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label='起运仓库'
                        prop="wareHouseId">
            <el-select v-model="inquiry.wareHouseId"
                       placeholder="请选择起运的仓库">
              <el-option v-for="item in wareHouse_optionsData"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='目的国家'
                        prop="siateId">
            <el-select v-model="inquiry.siateId"
                       @change='getStateFba'
                       placeholder="请选择您寄往的国家">
              <el-option v-for="item in optionsData"
                         :key="item.id"
                         :label="item.zh"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='FBA仓库代码'
                        v-if="inquiry.type!=2">
            <el-select v-model="inquiry.fbacode"
                       filterable
                       :placeholder="fbaCode.length==0?'未选择或国家不支持FBA':'如果需要寄往FBA请选择'">
              <el-option v-for="item in fbaCode"
                         :key="item.id"
                         :label="item.code?item.code+' ( '+item.zipcode+' )':''"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="control_btn">
        <div class="lineList">
          <div class="lineListView"
               v-if="lineList.length>0">
            <div>
              支持线路：
            </div>
            <el-radio-group v-model="activeName.name"
                            @change='inquireQuote()'
                            size="small">
              <el-radio :label="item.value"
                        v-for="item in lineList"
                        :key='item.value'
                        border>{{item.label}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <el-button type="primary"
                   @click="getLineList('inquiry')"
                   size="small">查 询 价 格</el-button>
      </div>
    </div>
    <div class="placeOrder_bottom">
      <inpuire-offer ref="inpuireoffer"
                     :line_id='activeName.name'
                     :type='inquiry.type'
                     :gjid='inquiry.siateId'
                     :ckid='inquiry.wareHouseId'
                     :fbacode='inquiry.fbacode'
                     v-show="inquiry.type==1&&lineList.length>0">

      </inpuire-offer>
      <div class="orderNull"
           v-if="inquiry.type !=1||lineList.length<=0">
        <div class="orderNull_text"
             v-if="inquiry.type==1">
          <el-empty description="请先在上方输入条件进行查询"></el-empty>
        </div>
        <div class="orderNull_text"
             v-if="inquiry.type==2">
          <el-empty description="集运下单时无需选择报价">
            集运下单流程<br /><br />
            1.复制支持集运仓库地址<br /><br />
            复制仓库地址后前往购物平台下单，将仓库地址粘贴到购物平台的收货地址中。<br /><br />
            2.包裹预报<br /><br />
            在购物平台获取包裹快递单号，将快递单号预报到系统中。<br /><br />
            3.申请打包<br /><br />
            收到包裹入库提示后，选好需要合并的包裹提交申请打包。<br /><br />
            4.运费支付<br /><br />
            完成支付后包裹自动出库。<br /><br /></el-empty>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import inpuireOffer from '@/components/inpuireOffer.vue'
import { apiTypeSite, apiUserWarehouse, apiFba, apiLineList } from '@/request/api'
export default {
  data () {
    return {
      // ===================【 加载动画 】 ===================
      fullscreenLoading: false,
      // ===================【 仓可选择的运输类型 】 ===================
      transportationType: [
        { label: '商业件', value: 1 },
        { label: '集运件', value: 2 },
      ],
      // ===================【 商业件的FBA数据 】 ===================
      fbaCode: [],
      // ===================【 仓库数据-包括集运和商业件 】 ===================
      wareHouseDate: {
        sy: [],
        jy: []
      },
      // ===================【 国家数据-包括集运和商业件 】 ===================
      siteDate: [],
      // ===================【 查询条件的校验 】 ===================
      inquiryRules: {
        type: [{ required: true, message: '运输类型必须选择' }],
        wareHouseId: [{ required: true, message: '起运仓库必须选择' }],
        siateId: [{ required: true, message: '目的地国家必须选择' }]
      },
      // ===================【 查询条件 】 ===================
      inquiry: {
        type: 1,
        wareHouseId: '',
        siateId: '',
        fbacode: ''
      },
      // ===================【 选择的线路 】 ===================
      activeName: {
        name: '0'
      },
      // ===================【 查询出来的线路 】 ===================
      lineList: []
    }
  },
  methods: {
    // -------------------【 查询报价-第二步获取报价 】 -------------------
    async inquireQuote () {
      this.fullscreenLoading = true
      this.$nextTick(() => {
        this.$refs.inpuireoffer.inquireQuote()
      })
      this.fullscreenLoading = false
    },
    // -------------------【 查询报价-第一步获取线路 】 -------------------
    getLineList (formName) {
      this.fullscreenLoading = true
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await apiLineList({
            gjid: this.inquiry.siateId
          })
          if (res.errno == 0) {
            this.lineList = [{
              label: "  全部",
              value: "0"
            }, ...res.line]
            this.activeName.name = '0'
            this.inquireQuote()
          } else {
            this.lineList = []
            this.$message.error('获取线路失败')
          }
        } else {
          return false;
        }
      });
      this.fullscreenLoading = false

    },
    // -------------------【 获取该国家的fba仓库 】 -------------------
    async getStateFba (e) {
      let res = await apiFba({
        pd: 'list',
        addrid: e,
      })
      if (res.errno == 0) {
        res.fbalist.unshift({
          address: "",
          addrid: "",
          city: "",
          code: "",
          id: "",
          province: "",
          uniacid: "",
          zipcode: ""
        })
        this.fbaCode = res.fbalist

      } else {
        this.fbaCode = []
      }
    },
    // -------------------【 获取仓库数据 】 -------------------
    async getWarehouse () {
      this.fullscreenLoading = true
      this.wareHouseDate = {
        sy: [],
        jy: []
      }
      let res = await apiUserWarehouse()
      if (res.errno == 0) {
        res.cklist.forEach(e => {
          if (e.type == 1) {
            this.wareHouseDate.sy.push(e)
          } else if (e.type == 2) {
            this.wareHouseDate.jy.push(e)
          } else if (e.type == 3) {
            this.wareHouseDate.sy.push(e)
            this.wareHouseDate.jy.push(e)
          }
        });
      }

      this.fullscreenLoading = false
    },
    // -------------------【 获取国家数据 】 -------------------
    async getState () {
      this.fullscreenLoading = true
      let res = await apiTypeSite()
      if (res.errno == 0) {
        this.siteDate = res.gjlist
      }
      this.fullscreenLoading = false
    }
  },
  computed: {
    // ===================【 根据运输类型切换仓库 】 ===================
    wareHouse_optionsData () {
      return this.inquiry.type == 1 ? this.wareHouseDate.sy : this.wareHouseDate.jy
    },
    // ===================【 根据运输类型切换国家 】 ===================
    optionsData () {
      return this.inquiry.type == 1 ? this.siteDate[1] : this.siteDate[2]
    }
  },
  components: {
    inpuireOffer
  },
  created () {
    this.getState()
    this.getWarehouse()
  }

}
</script>

<style lang='scss'>
.placeOrder {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .placeOrder_top,
  .placeOrder_bottom {
    flex: 1;
  }
  .placeOrder_top {
    max-height: 230px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .top_view {
      width: 90%;
      height: 150px;
      border-radius: 4px;
      padding: 0 40px;
      box-sizing: border-box;
      .inquiry_form {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: space-between;
        align-items: center;
        .el-select {
          .el-input__suffix {
            i {
              color: #333;
            }
          }
          .is-focus {
            input {
              border-bottom: 1px solid #409eff;
            }
          }
          input {
            border: 0;
            border-bottom: 1px solid #999;
            border-radius: 0;
            padding-left: 0;
            font-weight: 700;
          }
        }
        .el-form-item__label {
          font-weight: 700;
          letter-spacing: 1px;
          font-size: 14px;
        }
      }
    }
    .control_btn {
      width: 90%;
      height: 50px;
      text-align: right;
      line-height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .lineList {
        flex: 1;
        height: 100%;
        margin-right: 10px;
        margin-left: 40px;
        // background-color: pink;
        .lineListView {
          display: flex;
          font-size: 14px;
          color: #53a8ff;
          font-weight: 700;
          letter-spacing: 1px;
          align-items: center;
          .el-radio-group {
          }
          .el-radio {
            height: 27px;
            margin-right: 10px;
            padding: 0;
            padding: 0 20px !important;
            border-radius: 200px;
            line-height: 27px;
            transition: 0.1s all;
            .el-radio__label {
              padding-left: 0;
            }
            .el-radio__input {
              display: none;
            }

            .el-radio__input.is-checked + .el-radio__label {
              color: #fff;
            }
          }
          .el-radio.is-bordered.is-checked {
            background-color: #409eff;
          }
        }
      }
    }
  }
  .placeOrder_bottom {
    height: 0;
    background-color: #f5f5f5;
    .el-empty__bottom {
      color: #999;
      font-size: 14px;
    }
  }
}
</style>